import PropTypes from 'prop-types';
import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
// @mui
import  {Stack, Dialog, Button, DialogTitle, DialogActions, InputBase} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import { useSnackbar } from 'src/components/snackbar/index.js';
import { useBoolean } from 'src/hooks/use-boolean.js';
import Editor from 'src/components/editor';
import Iconify from 'src/components/iconify';
import {CREATE_EMAIL_TEMPLATE, UPDATE_EMAIL_TEMPLATE} from 'src/graphql/modules/_client/emailTemplate.js';
import { useMutation } from "@apollo/react-hooks";
// import SearchNotFound from 'src/components/search-not-found';

// ----------------------------------------------------------------------

export default function MailTemplateDialog({ title, emailDetails, classdetails, tempName, action, open, onClose, refreshQuery, _idToUpdate}) {
  const fullName = useSelector((state) => state?.auth?.user?.fullName);
    const { databaseName}  = useSelector((state) => state?.auth?.companyProfile?.companyProfile);
    const [eMessage, setEMessage] = useState("");
    const [subject, setSubject] = useState("")
    const [templateName, setTemplateName] = useState("")
    const [copySuccess, setCopySuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [EmailTemplateMutation] =  useMutation(CREATE_EMAIL_TEMPLATE);
    const [UpdateEmailTemplateMutation] = useMutation(UPDATE_EMAIL_TEMPLATE);

  const handleChange = (e) => {
    const {value} = e.target;
    setSubject(value);
  };


      useEffect(() => {
          if(emailDetails && _idToUpdate){
            setSubject(emailDetails?.subject)
            setEMessage(emailDetails?.emailMessage)
            setTemplateName(tempName)
          }
      }, [emailDetails])

    const handleTemplatename = (e) => {
    const {value} = e.target;
    setTemplateName(value);
  };

    const handleChangeMessage = useCallback((value) => {
      setEMessage(value);
    }, []);


  const handleSave = (async() =>{
    try {
      if(templateName === "" || templateName === null){
        enqueueSnackbar("Template name must not be empty.", {variant: "error"});
      }else {
      setIsLoading(true)
      const {data: {addEmailTemplate}} = await EmailTemplateMutation({
        variables: {
          companyName: databaseName,
            data: {
              templateName: templateName,
               subject: subject,
               message: eMessage,
               createdBy: fullName,
               createdDate: new Date(),
               modifiedBy: fullName,
               modifiedDate: new Date()
            }
          }
      })
      if(addEmailTemplate?.success){
        enqueueSnackbar("Email Template has been created.", {variant: "success"});
        setIsLoading(false)
        refreshQuery();
      }else{
        enqueueSnackbar("Unable to save the Email template.", {variant: "error"});
        setIsLoading(false)
      }
      }

    } catch (error){
      enqueueSnackbar("Server Error", {variant: "error"});
      setIsLoading(false)
    }
  })

  const handleUpdate = async(fstatus) => {
     try {
       const {data: { updateEmailTemplate }} = await UpdateEmailTemplateMutation({
         variables: {
           _id: _idToUpdate,
           companyName: databaseName,
             data: {
               templateName: templateName,
               subject: subject,
               message: eMessage,
               modifiedBy: fullName,
               modifiedDate: new Date()
             }
           }
       })
       if(updateEmailTemplate?.success){
         enqueueSnackbar('Update success!', {variant: 'success'});
         refreshQuery();
       }else {
         enqueueSnackbar('Failed to created', {variant: 'error'});
       }
 
     } catch(err){
       console.log(err)
     }
   }

    const handleCopy = async (copy) => {
    try {
      await navigator.clipboard.writeText(copy);
      setCopySuccess('Copied!');
    } catch (err) {
      setCopySuccess('Failed to copy!');
    }
  };

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={onClose}>
       <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 3, pr: 1.5 }}
      >
        <Stack direction="column" spacing={2}>
          <Button variant='outlined' onClick={() => { handleCopy('${course?.course?.courseTitle}')}}>Course Title</Button>
          <Button variant='outlined' onClick={() => { handleCopy('${course?.course?.courseDescription}')}}>Course Description</Button>
          <Button variant='outlined' onClick={() => { handleCopy('${fDate(course?.courseDates.start)}')}}>Start Date</Button>
          <Button variant='outlined' onClick={() => { handleCopy('${fDate(course?.courseDates.end)}')}}>End Date</Button>
          <Button variant='outlined' onClick={() => { handleCopy('${course?.venue?.block} ${course?.venue?.street} ${course?.venue?.building} #${course?.venue?.floor}-${course?.venue?.unit}')}}>Venue</Button>
          <Button variant='outlined' onClick={() => { handleCopy('${course?.classCode}')}}>Class Code</Button>
          <Button variant='outlined' onClick={() => { handleCopy('${course?.courseRunId}')}}>Course Run ID</Button>
            <span>{copySuccess}</span>
        </Stack>
        

        
      <Stack spacing={2} flexGrow={1} sx={{ p: 2 }} direction="column">

               <InputBase
                  placeholder="Template Name"
                  value={templateName}
                  onChange={(event) => handleTemplatename(event)}
                  sx={{
                    px: 2,
                    height: 48
                  }}
                  fullWidth
                  name="templateName"
                />

                <InputBase
                  placeholder="Subject"
                  value={subject}
                  onChange={(event) => handleChange(event)}
                  sx={{
                    px: 2,
                    height: 48
                  }}
                  fullWidth
                  name="subject"
                />


                  <Editor
                    
                    simple
                    id="compose-mail-template"
                    value={eMessage}  
                    onChange={handleChangeMessage}
                    placeholder="Type a message"
                      sx={{
                      '& .ql-editor': {}
                    }}
                  />
      </Stack>
      </Stack>
                <DialogActions>
                  <Stack spacing={2} direction="row" alignItems="center">
                    <LoadingButton
                      variant="contained"
                      color="primary"
                      endIcon={<Iconify icon="solar:diskette-bold-duotone" />}
                      onClick={() => { _idToUpdate ? handleUpdate() : handleSave() }}
                      loading={isLoading}
                    >
                      {_idToUpdate ? "Update" : "Save"}
                    </LoadingButton>

                      <LoadingButton
                      variant="contained"
                      color="error"
                      endIcon={<Iconify icon="solar:close-square-bold-duotone" />}
                      onClick={() => onClose()}
                    >
                      Close
                    </LoadingButton>
                  </Stack>
                </DialogActions>



    </Dialog>
  );
}

MailTemplateDialog.propTypes = {
  action: PropTypes.node,
  classdetails: PropTypes.any,
  emailDetails: PropTypes.any,
  tempName: PropTypes.any,
  onClose: PropTypes.func,
  _idToUpdate: PropTypes.string,
  open: PropTypes.bool,
  selected: PropTypes.func,
  title: PropTypes.string,
  refreshQuery: PropTypes.func
};
